import fragrances from './fragrances/rest'
import brands from './brands/rest'
import cart from './cart/rest'


export default {
  fragrances,
  brands,
  cart,
}
